module.exports = __webpack_public_path__ + "static/media/60004.b01101fb.png";